// Question item behaviors.
// Various behaviors to help with managing Question Items.
((Drupal) => {
  Drupal.behaviors.questionItem = {
    attach(context) {
      document
        .querySelectorAll(".js-question-item", context)
        .forEach((item) => {
          return (item.dataset.processedQuestionItem = true);
        });
    },

    // Set the state of a question item to default.
    setStateDefault(cssId) {
      const item = document.getElementById(cssId);
      if (!item) return;

      item.classList.remove(
        "question-item-is-delete-candidate",
        "question-item-is-delete-selected"
      );

      // Remove delete button and show default buttons.
      item
        .querySelectorAll(".js-btn-delete-select")
        .forEach((button) => button.remove());
      item
        .querySelectorAll(".footer .btn")
        .forEach((button) => button.classList.remove("d-none"));
    },

    // Set the state of a question item to delete candidate.
    setStateDeleteCandidate(cssId) {
      const item = document.getElementById(cssId);
      if (!item) return;

      item.classList.add("question-item-is-delete-candidate");
      item.classList.remove("question-item-is-delete-selected");

      // Hide default buttons and add delete button.
      item
        .querySelectorAll(".footer .btn")
        .forEach((button) => button.classList.add("d-none"));

      const footer = item.querySelector(".footer");
      if (footer) {
        const deleteButton = document.createElement("a");
        deleteButton.href = "#";
        deleteButton.className = "btn btn-primary js-btn-delete-select";
        deleteButton.textContent = Drupal.t("Select for deletion");
        deleteButton.addEventListener("click", (event) => {
          event.preventDefault();
          Drupal.behaviors.myListsSelectForDeletion.selectForDeletion(
            item.dataset.id
          );
        });
        footer.prepend(deleteButton);
      }
    },

    // Set the state of a question item to selected for deletion.
    setStateDeleteSelected(cssId) {
      const item = document.getElementById(cssId);
      if (!item) return;

      item.classList.remove("question-item-is-delete-candidate");
      item.classList.add("question-item-is-delete-selected");

      const deleteButton = item.querySelector(".js-btn-delete-select");
      if (deleteButton) {
        deleteButton.textContent = Drupal.t("Unselect for deletion");
        deleteButton.addEventListener("click", (event) => {
          event.preventDefault();
          Drupal.behaviors.myListsSelectForDeletion.unselectForDeletion(
            item.dataset.id
          );
        });
      }
    },
  };
})(Drupal);
